export default __webpack_public_path__ + "static/media/Access-encryption-diagram.0a26e353.svg";